import { render, staticRenderFns } from "./detailTka.vue?vue&type=template&id=074fc5cc"
import script from "./detailTka.vue?vue&type=script&lang=js"
export * from "./detailTka.vue?vue&type=script&lang=js"
import style0 from "./detailTka.vue?vue&type=style&index=0&id=074fc5cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports